module.exports = __webpack_public_path__ + "static/media/jplcovid19.032d95b9.jpg";